import { useAppState } from 'Context/AppContext/AppContext'
import InputSong from 'Components/SongComponents/FormSongs/InputSong/InputSong'
import { useForm } from 'react-hook-form'
import { DimensionInput } from 'TypeDefs/Objectives'
import { Dispatch, SetStateAction } from 'react'
import CloseIcon from '@material-ui/icons/Close'
import { analytics } from 'Modules/Analytics'
import { initiatives } from 'Modules/Analytics/trackActionInterface/Impact/Initiatives'
import { Container, DimensionColor, IconButton } from './DimensionItem.styles'

type DimensionItemProps = {
  index: number
  dimensionInfo: DimensionInput[]
  setDimensionInfo: Dispatch<SetStateAction<DimensionInput[]>>
  displayStartValue?: boolean
  isEditable?: boolean
  goalToDimensionId?: number | null
  handleDeleteCategoryArray?: (goalToDimensionId: number) => void
  isEditForm?: boolean
  initiativeId?: number | null
  goalId?: number | null
}

const DimensionItem = ({
  index,
  dimensionInfo,
  setDimensionInfo,
  displayStartValue = false,
  isEditable,
  goalToDimensionId,
  handleDeleteCategoryArray,
  isEditForm,
  initiativeId,
  goalId,
}: DimensionItemProps) => {
  const {
    nonprofitOrgConfig: { role, nonprofitOrgRole },
  } = useAppState()
  const dimension = dimensionInfo[index]
  const { title, startingValue } = dimension
  const { control } = useForm()

  const updateItem = (
    { target }: React.SyntheticEvent<Element, Event>,
    name: string
  ) => {
    const { value } = target as HTMLInputElement
    if (goalToDimensionId && handleDeleteCategoryArray && name === 'title') {
      handleDeleteCategoryArray(goalToDimensionId)
    }
    setDimensionInfo((currentDimensionInfo) => {
      const updatedDimensionInfo = [...currentDimensionInfo]
      updatedDimensionInfo[index] = {
        ...updatedDimensionInfo[index],
        [name]: name === 'startingValue' ? parseFloat(value) : value.trim(),
      }
      return updatedDimensionInfo
    })
  }

  const handleDeleteItem = async () => {
    analytics.trackActionCreator(initiatives.Delete_Category_Clicked)({
      role,
      relationship: nonprofitOrgRole,
    })
    if (goalToDimensionId && handleDeleteCategoryArray) {
      handleDeleteCategoryArray(goalToDimensionId)
    }

    setDimensionInfo((currentDimensionInfo) => {
      if (isEditForm) {
        analytics.trackActionCreator(
          initiatives.Goal_Edit_Chart_Delete_Category_Clicked
        )({
          categoryTitle: currentDimensionInfo[index].title,
          initiativeId,
          goalId,
        })
      }

      const updatedDimensionInfo = [...currentDimensionInfo]
      updatedDimensionInfo.splice(index, 1)
      return updatedDimensionInfo
    })
  }

  return (
    <Container displayStartValue={displayStartValue}>
      <InputSong
        name={title}
        control={control}
        required
        disabled={isEditable}
        type='text'
        onChangeHandler={(e) => updateItem(e, 'title')}
        defaultValue={title}
      />
      {displayStartValue && (
        <InputSong
          name={`startValue-${index}`}
          control={control}
          required
          type='number'
          onChangeHandler={(e) => updateItem(e, 'startingValue')}
          defaultValue={`${startingValue}`}
        />
      )}
      <DimensionColor index={index} />
      {dimensionInfo.length > 1 && (
        <IconButton aria-label='delete' onClick={handleDeleteItem}>
          <CloseIcon />
        </IconButton>
      )}
    </Container>
  )
}

export default DimensionItem

DimensionItem.defaultProps = {
  displayStartValue: false,
  isEditable: false,
  goalToDimensionId: null,
  handleDeleteCategoryArray: null,
  isEditForm: false,
  initiativeId: null,
  goalId: null,
}
